export default __webpack_public_path__ + "static/media/IS_Phone_Awareness_Cursor.64723536.jpg";